module.exports = __webpack_public_path__ + "img/detailJf.471dc1ef.png";